import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import pt from './locales/pt.json';
import en from './locales/en.json';
import { resolveInitialLanguage, DEFAULT_LANGUAGE } from './language';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      pt: { translation: pt },
      en: { translation: en },
    },
    lng: resolveInitialLanguage(),
    fallbackLng: DEFAULT_LANGUAGE,
    interpolation: {
      // React already escapes rendered values.
      escapeValue: false,
    },
    react: {
      // Catalogs are bundled, so nothing ever loads asynchronously.
      useSuspense: false,
    },
  });

export default i18n;
